import { Learning } from '@sandtech-hub-monorepo/ui-kit-site';

import { AppRoutesPaths } from '../../routes/types';
import {
  supportUrlFor,
  useIsActiveUniversityStudent,
} from '../../data/useLearnerPath';

/**
 * The degree learning view: the one an enrolled degree learner had before the
 * GSA split, unchanged. Reached at `/learning` via `pages/Learning/index.tsx`,
 * which picks it for a degree learner.
 */
export const DegreeLearning = () => {
  const isActiveUniversityStudent = useIsActiveUniversityStudent();

  return (
    <Learning
      paymentFAQsLink={AppRoutesPaths.PaymentFAQS}
      programPageLink={AppRoutesPaths.Program}
      learningPageLink={AppRoutesPaths.Learning}
      programsPageLink={AppRoutesPaths.Programs}
      supportPageLink={supportUrlFor(isActiveUniversityStudent)}
      universityOnly
    />
  );
};
